/**
 * Employee Web — `/me/profile` index route.
 *
 * Plan 05.2-05. Bare `/me/profile` redirects to `/me/profile/personal` so
 * the 6-tab shell always has an active tab. The pathless parent
 * `_auth.me.profile.tsx` already mounts the tab strip + outlet; the index
 * route is the redirect target for the empty path.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/me/profile/")({
  beforeLoad: () => {
    throw redirect({ to: "/me/profile/personal" });
  },
});
